export const cardsData = [
  {
    label: "Most Popular SAVE 55%",
    title: "3-Month Supply",
    subtitle: "Experience the benefits",
    freeShippingLabel: true,
    freeGiftsLabel: true,
    oldPrice: "",
    price: "$37.99",
    totalPrice: "",
    totalPriceOld: "$253.27",
    buyNowLabel: "ORDER NOW",
    img: `${window.template_root}/v1/onetime/3MonthSupply.svg`,
  },
  {
    label: "Best Value SAVE 60%",
    title: "6-Month Supply",
    subtitle: "Feel maximum results",
    freeShippingLabel: true,
    freeGiftsLabel: true,
    oldPrice: "",
    price: "$29.99",
    totalPrice: "",
    totalPriceOld: "$449.85",
    buyNowLabel: "ORDER NOW",
    img: `${window.template_root}/v1/onetime/6MonthSupply.svg`,
  },
  {
    label: "Basic",
    title: "1-Month Supply",
    subtitle: "Ideal solution for trying out",
    freeShippingLabel: false,
    freeGiftsLabel: false,
    oldPrice: "",
    price: "$69.99",
    totalPrice: "",
    totalPriceOld: "$139.98",
    buyNowLabel: "ORDER NOW",
    img: `${window.template_root}/v1/onetime/1MonthSupply2.png`,
  },
];

export const paymentIcons = [
  {
    img: `${window.template_root}/v1/onetime/payments/paypal.svg`,
    alt: "Paypal",
    width: 76,
    height: 21,
  },
  {
    img: `${window.template_root}/v1/onetime/payments/visa.svg`,
    alt: "Visa",
    width: 37,
    height: 25,
  },
  {
    img: `${window.template_root}/v1/onetime/payments/mastercard.svg`,
    alt: "Mastercard",
    width: 37,
    height: 25,
  },
  {
    img: `${window.template_root}/v1/onetime/payments/Amex.svg`,
    alt: "Amex",
    width: 36,
    height: 25,
  },
  {
    img: `${window.template_root}/v1/onetime/payments/diners-club.svg`,
    alt: "Dinner Club",
    width: 37,
    height: 25,
  },
  {
    img: `${window.template_root}/v1/onetime/payments/discover.svg`,
    alt: "Discover",
    width: 37,
    height: 25,
  },
];
